export const FONT_SMALL = 'font-small';
export const FONT_MEDIUM = 'font-medium';
export const FONT_LARGE = 'font-large';
